import builder from '../builder';
import Delete2 from '../../streamline-icons/light/delete-2.svg';

export default builder('IconDelete2Light', Delete2);
